var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"w-100 pointer-on-hover",class:{
    'nitro' : _vm.activeTab == _vm.question.key,
    'grey' : !_vm.question.user_answer ,
    'marker' : _vm.question.user_answer && _vm.activeTab != _vm.question.key ,
  },attrs:{"rounded":"sm","outlined":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"text-white text-center marker-number d-flex align-center justify-center"},[_vm._v("\n    "+_vm._s(_vm.question.key + 1)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"bg-white text-uppercase text-center marker-answer d-flex align-center justify-center"},[_vm._v("\n    "+_vm._s(_vm.question.user_answer)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }